import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { FormIoBuilderService } from 'src/app/formiobuilder/services/formiobuilder.service';
import {
  CreditPayment,
  SettingsInvoice,
} from '../../shared/models/invoice/invoice.model';
import { HeartlandObserverService } from '../../formiobuilder/services/heartland-observer.service';
import { FormObserverService } from '../../formiobuilder/services/form-observer.service';
import { CartsOrdersCalculator } from '../../shared/libraries/carts-orders-calculator';
import { ConfirmationService } from '../../formiobuilder/services/confirmations.service';
import { RecurringPayment } from '../../formiobuilder/models/recurring.model';
import { getAllComponents } from '../../formiobuilder/utilities/form';
import { formatCurrency } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceService } from '../../shared/services/invoice.service';
import { CreditPaymentService } from '../../shared/services/creditpayment.service';
import { AlertService } from '../../core/alert.service';
import { CustomerManagementService } from '../../shared/services/customer.service';
import { OrderService } from '../../formiobuilder/services/order.service';
import { ACHPaymentService } from '../../shared/services/achpayment.service';
import { TaxService } from '../../shared/services/tax.service';
import { MerchantService } from '../../shared/services/merchant.service';
import { SubscriptionService } from '../../shared/services/subscription-service.service';
import { TaxOrder } from '../../shared/models/settings/tax.model';
import { FormbuilderEmbedBaseComponent } from '../formbuilder-embed-base/formbuilder-embed-base.component';
import { CountriesService } from '../../shared/services/countries.service';
import { GooglePaymentService } from 'src/app/shared/services/googlepayment.service';
import { _ } from 'ag-grid-community';
import { PaymentService } from 'src/app/shared/services/payments.service';

@Component({
  selector: 'app-formbuilder-embed',
  templateUrl: './formbuilder-embed.component.html',
  styleUrls: ['./formbuilder-embed.component.scss'],
})
export class FormbuilderEmbedComponent
  extends FormbuilderEmbedBaseComponent
  implements OnInit, OnChanges
{
  recurringPaymentComponentKey: string;
  locationId: number;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public formioBuilderService: FormIoBuilderService,
    public invoiceService: InvoiceService,
    public merchantService: MerchantService,
    public dataSanitizer: DomSanitizer,
    public creditService: CreditPaymentService,
    public heartlandObserverService: HeartlandObserverService,
    public formObserverService: FormObserverService,
    public subscriptionService: SubscriptionService,
    public alertService: AlertService,
    public customerApiService: CustomerManagementService,
    public loadCountriesServices: CountriesService,
    public orderService: OrderService,
    public cartsOrdersCalculator: CartsOrdersCalculator,
    public achPaymentService: ACHPaymentService,
    public confirmationsService: ConfirmationService,
    public taxService: TaxService,
    public modalService: NgbModal,
    public googlePayService: GooglePaymentService,
    public paymentService: PaymentService
  ) {
    super(
      router,
      activatedRoute,
      formioBuilderService,
      invoiceService,
      merchantService,
      dataSanitizer,
      creditService,
      heartlandObserverService,
      formObserverService,
      alertService,
      customerApiService,
      loadCountriesServices,
      orderService,
      cartsOrdersCalculator,
      achPaymentService,
      confirmationsService,
      taxService,
      modalService,
      googlePayService,
      paymentService
    );

    this.invoiceSettingModel = new SettingsInvoice();
  }
  ngOnChanges(changes: SimpleChanges): void {
    // throw new Error('Method not implemented.');
  }

  ngOnInit() {
    this.formObserverService.castRecaptchaResponse.subscribe((response) => {
      this.recaptchaResponse = response;
    });

    /** for Product field dropdown */

    this.formObserverService.castselectedproductlists.subscribe(
      (selectedproductlist) => {
        this.selectedproductlist = selectedproductlist;
      }
    );

    this.formObserverService.casttotalselectedproduct.subscribe(
      (totalselectedproduct) => {
        this.totalselectedproduct = totalselectedproduct;
      }
    );

    this.formObserverService.castproductFieldLabel.subscribe(
      (productFieldlabel) => {
        this.productFieldlabel = productFieldlabel;
      }
    );

    /** for Terms and Condition field  */
    this.formObserverService.cast_termsconditioncontent.subscribe(
      (tc_content) => {
        this.tc_content = tc_content;
      }
    );
  }

  detectLocationComponent() {
    const locationComponent = this.allComponents.find((component) => {
      return component.componentType === 'location';
    });

    this.locationComponentKey = locationComponent?.key;
  }

  mapComputableComponents() {
    let price: any = [];
    let productField: any = [];
    let singleProductField: any = [];
    let shipping: any = [];
    let quantity: any = [];
    let discountAmount: any = [];
    let discountPercent: any = [];
    let taxAmount: string = '';
    let taxPercent: string = '';
    let subTotal: any = [];
    let total: any = [];
    let taxAmountDefaultValue: number = 0;
    let taxPercentDefaultValue: number = 0;
    let taxjarPercentDefaultValue: number = 0;
    let taxjarPercent: string = '';
    let commercialLineItems: any = [];

    this.allComponents.map((component) => {
      if (
        component.componentType === 'price' ||
        component.key.indexOf('price') !== -1
      ) {
        price.push(component.key);
      }
      if (
        component.type === 'productfield' ||
        component.key.indexOf('productfield') !== -1
      ) {
        productField.push(component.key);
      }
      if (
        component.type === 'singleproduct' ||
        component.key.indexOf('singleproduct') !== -1
      ) {
        singleProductField.push(component.key);
      }
      if (
        component.componentType === 'shipping' ||
        component.key.indexOf('shipping') !== -1
      ) {
        shipping.push(component.key);
      }
      if (
        component.componentType === 'quantity' ||
        component.key.indexOf('quantity') !== -1
      ) {
        quantity.push(component.key);
      }
      if (
        component.componentType === 'discountamount' ||
        component.key.indexOf('discountamount') !== -1
      ) {
        discountAmount.push(component.key);
      }
      if (
        component.componentType === 'discountpercent' ||
        component.key.indexOf('discountpercent') !== -1
      ) {
        discountPercent.push(component.key);
      }
      if (
        component.componentType === 'taxamount' ||
        component.key.indexOf('taxamount') !== -1
      ) {
        taxAmountDefaultValue = component.defaultValue;
        taxAmount = component.key;
      }
      if (
        component.componentType === 'taxpercent' ||
        component.key.indexOf('taxpercent') !== -1
      ) {
        taxPercentDefaultValue = component.defaultValue;
        taxPercent = component.key;
      }
      if (
        component.componentType === 'subtotal' ||
        component.key.indexOf('subtotal') !== -1
      ) {
        subTotal.push(component.key);
      }
      if (component.componentType === 'total' || component.key === 'total') {
        total.push(component.key);
      }
      if (component.type === 'commercialLineItem') {
        commercialLineItems.push(component.key);
      }
      if (
        component.componentType === 'taxjarfield' ||
        component.key.indexOf('taxjarfield') !== -1
      ) {
        taxjarPercentDefaultValue = component.defaultValue;
        taxjarPercent = component.key;
      }
    });

    this.computingComponents = {
      price: price,
      productField: productField,
      singleProductField: singleProductField,
      shipping: shipping,
      quantity: quantity,
      discountAmount: discountAmount,
      discountPercent: discountPercent,
      taxAmount: taxAmount,
      taxPercent: taxPercent,
      taxAmountDefaultValue: taxAmountDefaultValue,
      taxPercentDefaultValue: taxPercentDefaultValue,
      taxjarPercentDefaultValue: taxjarPercentDefaultValue,
      taxjarPercent: taxjarPercent,
      subTotal: subTotal,
      total: total,
      commercialLineItems: commercialLineItems,
    };
  }

  loadData(FormId: string) {
    // this.busy = true;
    this.formioBuilderService.getForm(FormId).subscribe(
      (res: any) => {
        if (res) {
          this.formIOModel = res;

          // validate if the one accessing here is a Subscription form
          if (this.formIOModel.Module === 'subscription') {
            this.router.navigateByUrl(
              `subscription/form/${this.formIOModel.id}/embed`
            );
          }

          this.formData = this.formIOModel.FormConfig;
          this.isValid = this.formIOModel.IsLive;
          this.allComponents = getAllComponents(this.formData.components);
          this.formObserverService.setFormData(this.formData.components);
          this.setFieldLabels();
          this.mapComputableComponents();
          this.detectLocationComponent();
          // Check if Heartland Payment is Active in the Form
          const heartlandComponent = this.allComponents.filter((component) => {
            return component.type === 'heartlandpayment';
          });

          if (heartlandComponent.length > 0) {
            this.locationId = heartlandComponent[0].customOptions.locationId;
          }

          // Tokenizer only
          const heartlandPaymentTokenizer = this.allComponents.filter(
            (component) => {
              return component.type === 'heartlandpaymenttokenizer';
            }
          );

          // Check if Card Form is available / activated
          this.isPaymentSystemComponentActive = heartlandComponent.length > 0;
          this.isCardFormActive =
            (this.isPaymentSystemComponentActive &&
              heartlandComponent[0]?.customOptions.paymentTypes.credit_card) ||
            heartlandPaymentTokenizer.length > 0;

          this.isRegisterCardComponentActive =
            heartlandPaymentTokenizer.length > 0;

          const recaptchaComponent = this.allComponents.filter((component) => {
            return component.type === 'recaptcha-v3';
          });

          this.isRecaptchaActive = recaptchaComponent.length > 0;

          // TaxJar Validation
          const taxJarComponent = this.allComponents.filter((component) => {
            return component.key === 'taxjarfield';
          });

          this.isTaxJarComponentActive = taxJarComponent.length > 0;

          if (this.isTaxJarComponentActive) {
            this.taxExemptionType =
              taxJarComponent[0].customOptions.taxjar_exemptiontype;

            this.taxService.getTaxSettings().subscribe((response: any) => {
              if (response) {
                this.isManualTaxjar = response.ManualTaxSetting;

                if (this.isManualTaxjar) {
                  this.taxService
                    .getAllManualTax()
                    .subscribe((taxes: any[]) => {
                      const selectedTaxes = taxes.filter((item) => {
                        return (
                          taxJarComponent[0].customOptions.manual_tax.indexOf(
                            item.Id
                          ) > -1
                        );
                      });
                      const totalTax = selectedTaxes.reduce(
                        (a: any, b: any) => ({
                          Percentage: a.Percentage + b.Percentage,
                        })
                      );
                      this.totalManualTax = totalTax.Percentage.toFixed(2);
                    });
                }
              }
            });
          }

          /** Check if Product Field is Active in the Form */
          const productComponent = this.allComponents.filter((component) => {
            return component.key === 'productfield';
          });

          this.isProductfieldActive = productComponent.length > 0;

          if (this.isProductfieldActive == true) {
            this.productlist = productComponent[0].data.values;
            this.productFieldlabel = productComponent[0].data.label;
            this.formObserverService.updateProductLists(this.productlist);
            this.formObserverService.updateProductFieldLabel(
              this.productFieldlabel
            );
          }
          // End product field dropdown */

          /** Check if Terms & Condition Field is Active in the Form */
          const TC_Component = this.allComponents.filter((component) => {
            return component.key === 'termscondition';
          });

          this.isTermsConditionfieldActive = TC_Component.length > 0;

          /** Check if Recurring Payment Component is Active in the Form */
          const recurringPaymentComponent = this.allComponents.find(
            (component) => {
              return component.componentType === 'recurringPayment';
            }
          );

          this.isRecurringForm = recurringPaymentComponent !== undefined;
          this.recurringPaymentComponentKey = recurringPaymentComponent?.key;
          this.formObserverService.setIsRecurringForm(this.isRecurringForm);

          /** Check if L2/L3 Component is Active in the Form */
          const commercialLineItemComponent = this.allComponents.find(
            (component) => {
              return component.type === 'commercialLineItem';
            }
          );

          this.formObserverService.setHasCommercialItem(
            commercialLineItemComponent !== undefined
          );

          this.confirmationsService
            .getConfirmationsByFormId(FormId)
            .subscribe((res2: any) => {
              this.confirmations = res2;
            });
        }
      },
      (error: any) => {
        this.busy = false;
        this.isValid = false;
        console.error('Invalid URL or form does not exist.');
      }
    );
  }

  onSubmit(submission: any) {
    this.busy = true;
    this.busy_message = 'Saving';

    this.submissionData = submission.data;
    this.submissionData.heartlandpayment = this.paymentFormInfo;

    // Check if recaptcha was validated
    if (this.isRecaptchaActive) {
      this.observeRecaptchaValidation();
      return;
    }

    this.preprocessSubmission();
  }

  saveCustomerCard() {
    this.cardModel.CardLast4Digits = this.cardToken.lastFour;
    this.cardModel.CardBrand = this.cardToken.cardType;
    this.cardModel.IsDeleted = false;
    this.cardModel.CreatedBy = this.userId;
    this.cardModel.CreatedDate = new Date();
    this.cardModel.UpdatedBy = null;
    this.cardModel.UpdatedDate = null;
    this.cardModel.ExpMonth = this.cardInfo.expMonth;
    this.cardModel.ExpYear = this.cardInfo.expYear;
    this.cardModel.Id = 0;
    this.cardModel.CustomerId = this.customerId;
    this.customerApiService.addCustomerCardNumber(this.cardModel).subscribe(
      (res) => {
        this.customerCardId = res;
        if (this.isRecurringForm) {
          this.saveRecurringPayment();
        } else if (this.isRegisterCardComponentActive) {
          this.alertSuccess({
            title: 'Success!',
            text: 'Card verified and saved!',
          });
        } else {
          this.sendReceipt().then(
            () => {
              this.alertSuccess({
                title: 'Success!',
                text: 'Form and Payment has been successfully submitted!',
              });
            },
            (err) =>
              this.alertService
                .alertWarning({
                  title: `Payment Successful<br>Sending Receipt Failed`,
                  text: `The payment was done successfully.<br> Unfortunately, there was an error encountered
                while sending the receipt.
                <br><br>Please contact ${this.businessInfo.BusinessName} and request for the receipt to be sent to your email.`,
                })
                .then(() => {
                  this.scrollToTop();
                  (window as any).location.reload();
                })
          );
        }
      },
      (err) => {
        this.alertService
          .alertWarning({
            title: 'Payment Successful<br>Saving Card failed',
            text: `Your payment was successfully processed<br>
            However, we have encountered problem while saving your card into your account.<br>
            Please contact ${this.businessInfo.BusinessName} for more information`,
          })
          .then(() => {
            this.scrollToTop();
            (window as any).location.reload();
          });
      }
    );
  }

  processCardPayment() {
    this.cardInfo.token = this.cardToken.token;
    this.cardInfo.number = this.cardToken.lastFour;
    this.cardInfo.cardBIN = this.cardToken.cardBIN;
    this.cardInfo.expMonth = this.cardToken.expMonth;
    this.cardInfo.expYear = this.cardToken.expYear;

    const creditData = new CreditPayment();
    const saveCard: boolean = this.paymentFormData?.customerData.saveCard;
    creditData.currency = 'USD';
    creditData.cardInfo = this.cardInfo;
    creditData.amount = this.cardToken.amount;
    creditData.invoiceNumber = this.invoiceNumber;
    creditData.terminalId = 'MAIN';
    creditData.customerId = this.customerId;
    creditData.orderId = this.orderId;
    creditData.billingAddress = this.customerAddress;
    creditData.requestMultiUseToken = saveCard;
    creditData.htoken = this.captchaToken;
    creditData.hApiKeyId = this.captchaApiKeyId;

    this.creditService
      .creditChargeForm(
        creditData,
        this.userId.toString(),
        this.locationComponentSelectedData.Id || this.cardToken.locationData.Id,
        'Main'
      )
      .subscribe(
        (chargeRes: any) => {
          this.transactionId = chargeRes.transactionId;
          if (chargeRes) {
            if (this.customerSignature) {
              //save customer signature.
              this.invoiceService
                .uploadCustomersig({
                  invoiceNumber: this.invoiceNumber,
                  signatureUrl: this.customerSignature,
                  createdBy: 1,
                })
                .subscribe((res) => {
                  if (saveCard) {
                    this.cardModel.Token = chargeRes.token;
                    this.saveCustomerCard();
                  } else {
                    this.sendReceipt().then(
                      () => {
                        this.alertSuccess({
                          title: 'Success!',
                          text: 'Form and Payment has been successfully submitted!',
                        });
                      },
                      (err) =>
                        this.alertService
                          .alertWarning({
                            title: `Payment Successful<br>Sending Receipt Failed`,
                            text: `The payment was done successfully.<br> Unfortunately, there was an error encountered
                      while sending the receipt.
                      <br><br>Please contact ${this.businessInfo.BusinessName} and request for the receipt to be sent to your email.`,
                          })
                          .then(() => {
                            this.scrollToTop();
                            (window as any).location.reload();
                          })
                    );
                  }
                });
            } else {
              if (saveCard) {
                this.cardModel.Token = chargeRes.token;
                this.saveCustomerCard();
              } else {
                this.sendReceipt().then(
                  () => {
                    this.alertSuccess({
                      title: 'Success!',
                      text: 'Form and Payment has been successfully submitted!',
                    });
                  },
                  (err) =>
                    this.alertService
                      .alertWarning({
                        title: `Payment Successful<br>Sending Receipt Failed`,
                        text: `The payment was done successfully.<br> Unfortunately, there was an error encountered
                    while sending the receipt.
                    <br><br>Please contact ${this.businessInfo.BusinessName} and request for the receipt to be sent to your email.`,
                      })
                      .then(() => {
                        this.scrollToTop();
                        (window as any).location.reload();
                      })
                );
              }
            }
          }
        },
        (err) => {
          const captchaRenderer: any =
            document.getElementById('captchaRenderBtn');

          if (captchaRenderer) captchaRenderer.click();

          this.alertError({
            title: 'Payment failed',
            text: 'We are unable to process your payment. Please contact your administrator.',
          });
        }
      );
  }

  updateAmountTotal(eventData: any, event: any) {
    if (this.isCardFormActive && typeof event.isValid === 'boolean') {
      // this detects if the Form is valid / invalid
      this.formObserverService.updateFormValidation(event.isValid);
    }

    this.resizeFrame();
    if (eventData) {
      //  Logic for File component
      if (eventData.file && eventData.file.length > 0) {
        const removeLink = document.getElementsByClassName(
          'formio-component-file'
        ) as unknown as HTMLElement;
        if (typeof removeLink[0].children[1].children[1] !== undefined) {
          removeLink[0].children[1].children[1].children[0].children[0].style.cursor =
            'pointer';
          removeLink[0].children[1].children[1].children[0].children[0].addEventListener(
            'click',
            () => {
              eventData.file[0] = {};
              this.ready(event, 'restoreForm');
            }
          );
        }
      }

      // if not,undefined,null,empty value then...
      const orderAdjustments: any = [];
      let hasComputableAmountFields = false;
      let amountPayable: number = 0;
      let subTotal: number = 0;
      let grandTotal: number = 0;

      // Added for Subscription Total
      if (eventData && eventData.PlanPrice) {
        amountPayable += eventData.PlanPrice;
        hasComputableAmountFields = true;
      }

      Object.keys(eventData).map((key) => {
        const priceElement = this.computingComponents.price.indexOf(key);

        if (priceElement !== -1) {
          let amountToAdd = eventData[key];
          const quantity = this.computingComponents.quantity[priceElement];
          if (quantity) {
            amountToAdd *= eventData[quantity];
          }
          amountPayable += amountToAdd;
          hasComputableAmountFields = true;
        }

        const shippingElement = this.computingComponents.shipping.indexOf(key);
        if (shippingElement !== -1) {
          amountPayable += eventData[key];
          hasComputableAmountFields = true;
        }

        const productFieldElement =
          this.computingComponents.productField.indexOf(key);
        if (productFieldElement !== -1) {
          amountPayable += eventData[key].amount || 0;
          hasComputableAmountFields = true;
        }

        const singleProductFieldElement =
          this.computingComponents.singleProductField.indexOf(key);
        if (singleProductFieldElement !== -1) {
          amountPayable += eventData[key].productSubtotal || 0;
          hasComputableAmountFields = true;
        }

        const commercialItemsFieldElement =
          this.computingComponents.commercialLineItems.indexOf(key);

        if (commercialItemsFieldElement !== -1) {
          amountPayable += eventData[key].Amount * eventData[key].Quantity || 0;
          hasComputableAmountFields = true;
        }
      });

      subTotal = amountPayable;
      this.itemsTotal = subTotal;

      // Discount Computation
      Object.keys(eventData).map((key) => {
        const discountAmountElement =
          this.computingComponents.discountAmount.indexOf(key);
        if (discountAmountElement !== -1) {
          amountPayable -= eventData[key];
          hasComputableAmountFields = true;

          orderAdjustments.push({
            id: 0,
            adjustmentType: 'DISCOUNT',
            adjustmentName: 'DISCOUNT',
            amount: eventData[key],
            percentValue: 0,
          });
        }

        const discountPercentElement =
          this.computingComponents.discountPercent.indexOf(key);
        if (discountPercentElement !== -1) {
          amountPayable -= subTotal * +(eventData[key] / 100);
          hasComputableAmountFields = true;

          orderAdjustments.push({
            id: 0,
            adjustmentType: 'DISCOUNT',
            adjustmentName: 'DISCOUNT %',
            amount: 0,
            percentValue: eventData[key],
          });
        }
      });

      // Fill SubTotal
      Object.keys(eventData).map((key) => {
        const subTotalElementName =
          this.computingComponents.subTotal.indexOf(key);
        if (subTotalElementName !== -1) {
          const subTotalElement: HTMLInputElement = <HTMLInputElement>(
            document.querySelector("[name='data[" + key + "]']")
          );
          subTotalElement.value = formatCurrency(amountPayable, 'en-US', '$');
        }
      });

      this.subTotal = amountPayable || 0;
      grandTotal = amountPayable || 0;

      // Tax Computations
      const taxAmountElementName = this.computingComponents.taxAmount;
      const taxPercentElementName = this.computingComponents.taxPercent;
      const changedComponent = event.changed;

      if (taxAmountElementName && taxPercentElementName) {
        let amountToTax = eventData[taxAmountElementName] || 0;
        let rateToTax = eventData[taxPercentElementName] || 0;

        if (eventData[taxAmountElementName] === undefined) {
          amountToTax = this.computingComponents.taxAmountDefaultValue;
        }

        if (eventData[taxPercentElementName] === undefined) {
          rateToTax = this.computingComponents.taxPercentDefaultValue;
        }

        const isAmountChanged =
          (changedComponent &&
            changedComponent.component &&
            changedComponent.component.key === taxAmountElementName) ||
          false;
        const isTaxChanged =
          (changedComponent &&
            changedComponent.component &&
            changedComponent.component.key === taxPercentElementName) ||
          false;

        const taxAmountElement: HTMLInputElement = <HTMLInputElement>(
          document.querySelector("[name='data[" + taxAmountElementName + "]']")
        );
        if (
          taxAmountElement &&
          (isTaxChanged || (!isTaxChanged && !isAmountChanged))
        ) {
          taxAmountElement.value = formatCurrency(
            this.itemsTotal * (rateToTax / 100),
            'en-US',
            '$'
          );
        }

        const taxPercentElement: HTMLInputElement = <HTMLInputElement>(
          document.querySelector("[name='data[" + taxPercentElementName + "]']")
        );
        if (taxPercentElement && isAmountChanged) {
          taxPercentElement.value =
            ((amountToTax / this.itemsTotal) * 100 || 0) + '';
        }

        amountPayable += this.itemsTotal * (rateToTax / 100);
        hasComputableAmountFields = true;
        orderAdjustments.push({
          id: 0,
          adjustmentType: 'TAX',
          adjustmentName: 'TAX',
          amount: this.itemsTotal * (rateToTax / 100),
          percentValue: 0,
        });
      } else if (taxAmountElementName) {
        const amountToTax = eventData[taxAmountElementName] || 0;
        amountPayable += amountToTax;
        hasComputableAmountFields = true;
        orderAdjustments.push({
          id: 0,
          adjustmentType: 'TAX',
          adjustmentName: 'TAX',
          amount: amountToTax,
          percentValue: 0,
        });
      } else if (taxPercentElementName) {
        const rateToTax = eventData[taxPercentElementName] || 0;

        amountPayable += this.itemsTotal * +(rateToTax / 100);
        hasComputableAmountFields = true;
        orderAdjustments.push({
          id: 0,
          adjustmentType: 'TAX',
          adjustmentName: 'TAX %',
          amount: 0,
          percentValue: rateToTax,
        });
      }

      if (this.isTaxJarComponentActive) {
        const taxjarPercentElementName = this.computingComponents.taxjarPercent;
        const taxjarPercentElement: HTMLInputElement = <HTMLInputElement>(
          document.querySelector(
            "[name='data[" + taxjarPercentElementName + "]']"
          )
        );

        // Added for taxjar implementation
        let tax_state = eventData.states || eventData.states1;
        let tax_zipcode = eventData.postcode1 || eventData.postcode;
        let myPostCode = tax_zipcode ? tax_zipcode.replace('_', '') : '';

        let taxjarPayloadDetails = [
          {
            country: eventData.countries,
            states: tax_state,
            zipcode: tax_zipcode,
            address: eventData.address,
            city: eventData.city ? eventData.city : '',
            shipping: eventData.shipping ? eventData.shipping : 0,
            taxable_amount: amountPayable,
          },
        ];
        let rateToTax = 0;
        if (this.isManualTaxjar) {
          rateToTax = this.totalManualTax || 0;
          amountPayable += this.itemsTotal * +(rateToTax / 100);
          hasComputableAmountFields = true;
          orderAdjustments.push({
            id: 0,
            adjustmentType: 'TAX',
            adjustmentName: 'TAX %',
            amount: 0,
            percentValue: rateToTax,
          });

          if (taxjarPercentElement) {
            taxjarPercentElement.value = rateToTax + '';
          }
        } else {
          const addressToCompare =
            eventData.countries + tax_state + tax_zipcode;
          rateToTax = this.taxJarAPIRate;
          if (taxjarPercentElement) {
            taxjarPercentElement.value = rateToTax + '';
          }

          if (this.taxAddressStorage !== addressToCompare) {
            if (
              (eventData.countries == 'USA' &&
                tax_state != '' &&
                tax_zipcode != '' &&
                myPostCode.length == 5) ||
              (eventData.countries != 'USA' &&
                tax_state != '' &&
                tax_zipcode != '' &&
                myPostCode.length >= 3)
            ) {
              this.computeTax(taxjarPayloadDetails).then((res: any) => {
                rateToTax = res || 0;
                this.taxJarAPIRate = rateToTax;
                this.taxAddressStorage = addressToCompare;
                amountPayable += this.itemsTotal * +(rateToTax / 100);
                hasComputableAmountFields = true;
                orderAdjustments.push({
                  id: 0,
                  adjustmentType: 'TAX',
                  adjustmentName: 'TAX %',
                  amount: 0,
                  percentValue: rateToTax,
                });

                if (taxjarPercentElement) {
                  taxjarPercentElement.value = rateToTax + '';
                }

                Object.keys(eventData).map((key) => {
                  const totalElementName =
                    this.computingComponents.total.indexOf(key);
                  if (totalElementName !== -1) {
                    const totalElement: HTMLInputElement = <HTMLInputElement>(
                      document.querySelector("[name='data[" + key + "]']")
                    );
                    totalElement.value = formatCurrency(
                      amountPayable,
                      'en-US',
                      '$'
                    );
                  }
                });

                this.total = amountPayable;

                if (hasComputableAmountFields) {
                  this.heartlandObserverService.updateAmountData(amountPayable);
                }
                this.orderAdjustments = orderAdjustments;
              });
            }
          }
        }
      } else {
        Object.keys(eventData).map((key) => {
          const totalElementName = this.computingComponents.total.indexOf(key);
          if (totalElementName !== -1) {
            const totalElement: HTMLInputElement = <HTMLInputElement>(
              document.querySelector("[name='data[" + key + "]']")
            );
            totalElement.value = formatCurrency(amountPayable, 'en-US', '$');
          }
        });

        this.total = amountPayable;

        if (hasComputableAmountFields) {
          this.heartlandObserverService.updateAmountData(amountPayable);
        }
        this.orderAdjustments = orderAdjustments;
      }
    }
  }

  saveRecurringPayment() {
    const recurringPayment = new RecurringPayment();
    recurringPayment.FormId = this.FormId;
    recurringPayment.FormDataId = this.formEntry.Id;
    recurringPayment.OrderId = this.orderId;
    recurringPayment.CustomerCardNumberId = this.customerCardId;
    recurringPayment.StartDate = new Date();
    recurringPayment.EndDate = null;
    recurringPayment.FrequencyConfigurationId =
      this.submissionData[this.recurringPaymentComponentKey]?.id;
    recurringPayment.IsRecurringPayment = true;
    recurringPayment.LocationId = this.locationId;

    if (
      this.isRecurringForm &&
      this.submissionData[this.recurringPaymentComponentKey]
    ) {
      const recurringPaymentComponent = this.allComponents.find(
        (component) => component.componentType === 'recurringPayment'
      );
      recurringPayment.IsAutoCharge =
        recurringPaymentComponent?.customOptions?.isAutoCharge || false;
    }

    this.formioBuilderService
      .saveRecurringInvoicePayment(recurringPayment)
      .subscribe(
        (res) => {
          if (this.customerSignature) {
            //save customer signature.
            this.invoiceService
              .uploadCustomersig({
                invoiceNumber: this.invoiceNumber,
                signatureUrl: this.customerSignature,
                createdBy: 1,
              })
              .subscribe((res) => {
                this.alertSuccess({
                  title: 'Success!',
                  text: 'Form and Payment has been successfully submitted!',
                });
              });
          } else {
            this.alertSuccess({
              title: 'Success!',
              text: 'Form and Payment has been successfully submitted!',
            });
          }
          this.busy = false;
        },
        (error) => {
          this.alertError({
            title: 'Error!',
            text: 'Something went wrong. Please contact administrator.',
          });

          this.busy = false;
        }
      );
  }

  // added for taxjar implementations
  computeTax(taxjarPayloadDetails: any[]): Promise<any> {
    return new Promise((resolve, reject) => {
      let taxOrderPayload = new TaxOrder();

      taxOrderPayload.FromCountry = this.findCountryCode(
        this.businessInfo.CountryCode
      );
      taxOrderPayload.FromZip = this.businessInfo.PostalCode
        ? this.businessInfo.PostalCode
        : '';
      taxOrderPayload.FromState = this.businessInfo.StateId
        ? this.businessInfo.StateId
        : '';
      taxOrderPayload.FromCity = this.businessInfo.City
        ? this.businessInfo.City
        : '';
      taxOrderPayload.FromStreet = this.businessInfo.Address
        ? this.businessInfo.Address
        : '';

      let toCountry = this.findCountryCode(taxjarPayloadDetails[0].country);
      taxOrderPayload.ToCountry = toCountry
        ? toCountry
        : taxOrderPayload.FromCountry;
      taxOrderPayload.ToZip = taxjarPayloadDetails[0].zipcode
        ? taxjarPayloadDetails[0].zipcode
        : taxOrderPayload.FromZip;
      taxOrderPayload.ToState = taxjarPayloadDetails[0].states
        ? taxjarPayloadDetails[0].states
        : taxOrderPayload.FromState;
      taxOrderPayload.ToCity = taxjarPayloadDetails[0].city
        ? taxjarPayloadDetails[0].city
        : taxOrderPayload.FromCity;
      taxOrderPayload.ToStreet = taxjarPayloadDetails[0].address
        ? taxjarPayloadDetails[0].address
        : taxOrderPayload.FromStreet;

      taxOrderPayload.Amount = taxjarPayloadDetails[0].taxable_amount
        ? taxjarPayloadDetails[0].taxable_amount
        : 0;
      taxOrderPayload.Shipping = taxjarPayloadDetails[0].shipping;
      taxOrderPayload.CustomerId = '';
      taxOrderPayload.ExemptionType = this.taxExemptionType || 'non_exempt';
      taxOrderPayload.nexusAddress = null;
      taxOrderPayload.lineItem = []; // to consider for store embed
      taxOrderPayload.lineItem.push({
        Id: '',
        Quantity: 1,
        ProductTaxCode: '',
        UnitPrice: this.subTotal,
        Discount: 0,
      });

      this.taxService.getTaxJarRate(taxOrderPayload).subscribe(
        (response: any) => {
          if (response) {
            resolve(response.rate);
          } else {
            resolve(0);
          }
        },
        (error: any) => {
          resolve(0);
        }
      );
    });
  }
}
